import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useUnviewedCount } from '@/hooks/use-notifications'

export function NotificationBanner() {
  const { data: count, isError } = useUnviewedCount()
  const [dismissed, setDismissed] = useState(false)

  // Reset dismissed when count changes (new notifications arrived)
  useEffect(() => {
    if (count && count > 0) setDismissed(false)
  }, [count])

  // Silently hide on error or zero count
  if (isError || !count || count === 0 || dismissed) return null

  return (
    <div className="bg-brand-teal/10 border-b border-brand-teal/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5 flex items-center justify-between">
        <div className="flex items-center gap-2 text-sm text-brand-teal">
          {/* Bell icon */}
          <svg className="w-4 h-4 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
          </svg>
          <span>
            You have <strong>{count}</strong> new action plan{count !== 1 ? 's' : ''} to review
          </span>
        </div>
        <div className="flex items-center gap-3">
          <Link
            to="/notifications"
            className="text-sm font-medium text-brand-teal hover:text-brand-teal/80 underline underline-offset-2"
          >
            Review
          </Link>
          <button
            onClick={() => setDismissed(true)}
            className="text-brand-teal/60 hover:text-brand-teal"
          >
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  )
}
